import styled from "styled-components";
import ButtonUtil from "../UI/ButtonUtil";
import { useTranslation } from "react-i18next";
import { useWindowSize } from "context/WindowSizeContext";

const IconBtnWrap = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-around;
    margin-top: 10px;
    button {
        width: 40%;
        background-color: #fff;
        border: 1px solid #dddddd;
        border-radius: 8px;
        height: 120px;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        transition: all .3s ease-in-out;
        &:hover {
            border: 2px solid ${({ theme }) => theme.colors.red};
        }
        h4 {
            color: ${({ theme }) => theme.colors.dark2};
            font-weight: 400;
            text-align: center;
            line-height: 130%;
            margin-top: 5px;
        }
    }
`;
const LabelText = styled.h4`
  font-size: ${({ $value, $language, $isMobile }) =>
    $language && $isMobile && ($value === "OFF" || $value === "PRGM")
      ? "11px"
      : $language && $isMobile
        ? "12px"
        : $isMobile
          ? "14px"
          : "16px"};
`;
const ImageWrap = styled.div`
    ${({ $png }) =>
        $png ? 
    `
        width: 25px;
        height: 26px;
        display: flex;
        justify-content: center;
        align-items: center;
        img {
            width: 20px;
            height: 20px;
        }
    ` : `
        img {
            width: auto;
            height: auto;
        }
    `}
`;

export default function CmmnTestPrintIcon(
    {
        dataArray,
        handleClick,
    }
) {

    const {  i18n } = useTranslation();
    const jp = i18n.language === "jp"
    const isMobile = useWindowSize();

    return (
        <IconBtnWrap $language={jp} $isMobile={isMobile}>
            {dataArray.map((data, idx) => (
                <ButtonUtil key={idx}
                    onClick={() => handleClick(data.value)}
                >
                    <ImageWrap $png={data.value === "OFF"}>
                        <img src={data.img} alt={`${data.img}_logo`} />
                    </ImageWrap>
                    <LabelText $value={data.value} $language={jp} $isMobile={isMobile}>
                        {data.label}
                    </LabelText>
                </ButtonUtil>
            ))}
        </IconBtnWrap>
    )
}